export default __webpack_public_path__ + "images/a051c45129531444da8ff7e33f4b1ce4.svg";